import { NgModule } from '@angular/core';
import { TasksListComponent } from './tasks-list.component';
import { CommonModule, DatePipe, NgClass } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
	declarations: [TasksListComponent],
	exports: [TasksListComponent],
	imports: [NgClass, MatTableModule, DatePipe, MatPaginatorModule, CommonModule, MatButtonModule],
})
export class TasksListModule {}
